/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Sso_CoveredInputs */



/**
* | output |
* | --- |
* | "Your company signs in with its single sign-on service. Continue there with this email address." |
*
* @param {Signin_Sso_CoveredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const signin_sso_covered = /** @type {((inputs?: Signin_Sso_CoveredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Sso_CoveredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Your company signs in with its single sign-on service. Continue there with this email address.")
});